module.exports = __webpack_public_path__ + "static/media/template5-carousel.8a136d47.png";